import { PowerPlan, PowerPlanDetails, SolutionsUsingPowerPlan } from "@/services/powerPlans/types";
import api from "@/services/api";

export function getPowerPlans() : Promise<PowerPlan[]> {
    return new Promise((resolve, reject) => {
        api.get("/powerPlans").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function getPowerPlan(id: string) : Promise<PowerPlanDetails> {
    return new Promise((resolve, reject) => {
        api.get(`/powerPlans/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function createPowerPlan(powerPlan: PowerPlanDetails) : Promise<PowerPlanDetails> {
    return new Promise((resolve, reject) => {
        api.post(`/powerPlans`, powerPlan).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function updatePowerPlan(powerPlan: PowerPlanDetails) : Promise<string> {
    return new Promise((resolve, reject) => {
        api.put(`/powerPlans`, powerPlan).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function deletePowerPlan(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        api.delete(`/powerPlans/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDelete(id: string): Promise<SolutionsUsingPowerPlan[]> {
    return new Promise((resolve, reject) => {
        api.get(`/powerPlans/checkdelete/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function copyPowerPlan(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        api.post(`/powerPlans/copy/${id}`, null).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
